import { configureStore } from '@reduxjs/toolkit';
import { stepSlice, filesSlice, uploadSlice, thumbnailSlice, gallerySlice, siteSlice } from './slices';
import {createEpicMiddleware} from "redux-observable";
import {rootEpic} from "./epics";
import { Action } from 'redux';

const epicMiddleware = createEpicMiddleware<Action, Action, any, any>();

export const store = configureStore({
  reducer: {
    step: stepSlice.reducer,
    files: filesSlice.reducer,
    upload: uploadSlice.reducer,
    thumbnails: thumbnailSlice.reducer,
    gallery: gallerySlice.reducer,
    site: siteSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['files/setFiles', 'files/addFiles', 'upload/uploadFile'],
        ignoredPaths: ['files.files'],
      },
    }).concat(epicMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

epicMiddleware.run(rootEpic);
